.kdx-site-search {
    position: relative;    
    margin: 0;

    &.input-group {
        > .form-control {
            margin: 0;
            border-radius: 6px;
            border: 1px solid #ccc;
            padding: 0 40px 0 10px;
            height: 40px;

			font-style: italic;
			color: #505050;
		
			@include placeholder() {
				color: #505050;
				font-style: italic;
			}
            &:focus, &:active {
                z-index: auto; // Bootstrap override                
            }
        }

        // Bootstrap override
        > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
            margin: 0;
			border-radius: 6px;

			&.input-group-text { border-radius: 0 6px 6px 0; }
        }
    }

    .input-group-text {
        background-color: #fff;
        border: none;
        border-radius: 0;
        position: absolute;
        right: 1px;
        top: 1px;
		padding: 1px 10px 5px 10px;
		border-radius: 0 6px 6px 0;
		height: 38px;
    }

    > .form-control {
        border: none;
        border-radius: 0;
        @include text-size(15);
        color: $senary;
        padding: 0;        

        &::placeholder {
            color: $senary;
            @include text-size(15);
        }

        &:active, &:focus {
            border: none;
            outline: none;
            box-shadow: none;
        }
    }

    .svg-icon {
        svg {
            @include svg-format(14px, 15px, $primary);
            transform: translateY(3px);
        }
    }    
    &.has-focus {
		&.input-group {
			> .form-control {
				border: 1px solid $primary;
				box-shadow: 0 0 6px $primary;
			}		
		}
		.input-group-text {
			background: $primary;
			right: 0;
			top: 0px;
			height: 39px;

			svg { fill: #FFF; }
		}
    }

    @include media-breakpoint-down(lg) {
        flex-wrap: nowrap;

        input[type="text"] {
            padding: 10px;
            height: auto;
            max-height: none;
        }

        &.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {

            svg {
                fill: #fff;
            }
			&.input-group-text {
                background-color: $primary;
            }
        }

        button[type="submit"] {
            width: auto;
            padding-right: 10px !important;
        }
    }
}
